import { APP_PRIMARY_COLOR } from './constants/appConstants';
import { COUNTY_EDIT_CONTRACTOR } from './constants/dictionariesButtonsConstants';
import Swal from 'sweetalert2';
import repositoryGeneric from './repositoryGeneric';
import { handleResponseWithMessages } from '@/helpers/wwwHelper.js';

export function onCustomButtonClicked(buttonId, element, refreshAction = null) {
  switch (buttonId) {
    case COUNTY_EDIT_CONTRACTOR.id:
      onCountyEditContractor(element, refreshAction);
      break;
    default:
      console.warn(`onCustomButtonClicked(): No handler defined for button ID: ${buttonId}`);
  }
}

function onCountyEditContractor(element, refreshAction) {
  if (!element || !element.id) {
    console.error('onCountyEditContractor(): Invalid element provided');
    return;
  }

  const swalConfiguration = {
    title: 'Zmiana nazwy wykonawcy',
    html: 'Podaj nową nazwę.',
    icon: 'info',
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonColor: `#${APP_PRIMARY_COLOR}`,
    cancelButtonColor: '#f8ac59',
    confirmButtonText: 'Zatwierdź',
    cancelButtonText: 'Anuluj',
    customClass: {
      title: 'swal2-title'
    },
    width: '',
    input: 'text',
    inputValue: element?.contractor_info ?? '',
    inputPlaceholder: 'Nazwa wykonawcy'
  };

  Swal.fire(swalConfiguration).then((result) => {
    if (result.value) {
      updateContractorInfo(element.id, result.value, refreshAction);
    }
  });
}

async function updateContractorInfo(countyId, newContractorName, refreshAction) {
  const response = await repositoryGeneric.fetchPostAndQueryParams(
    `powiat/${countyId}/updateContractorInfo`,
    null,
    { contractor_info: newContractorName }
  );

  handleResponseWithMessages(response, 'Nazwa wykonawcy została zmieniona.', () => {
    if (typeof refreshAction === 'function') {
      refreshAction();
    }
  });
}
